(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drv-article-reader"] && !Shopify.designMode) return;
  try {
    
class DrvArticleReader extends HTMLElement {
  static uniqueId(text, prefix, used) {
    const slug = text.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'section';
    const base = prefix + '-' + slug;
    let id = base, n = 2;
    while (used.has(id)) id = base + '-' + n++;
    used.add(id);
    return id;
  }
  connectedCallback() {
    queueMicrotask(() => { if (this.isConnected) this.init(); });
  }
  init() {
    this.abort?.abort();
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.body = this.querySelector('[data-reader-body]');
    this.toc = this.querySelector('.drv-article-reader__toc');
    this.details = this.toc.querySelector('details');
    this.nav = this.toc.querySelector('nav');
    this.list = this.nav.querySelector('ol');
    this.mobile = matchMedia('(max-width:989px)');
    this.details.open = !this.mobile.matches;
    const cover = this.querySelector('[data-reader-cover]');
    if (cover) {
      const intro = this.body.querySelector(':scope > p');
      if (intro) intro.after(cover); else this.body.prepend(cover);
    }
    this.build();
    this.toc.addEventListener('click', event => {
      const link = event.target.closest('a[data-reader-index]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = this.headings[Number(link.dataset.readerIndex)];
      if (!target) return;
      event.preventDefault();
      if (this.mobile.matches) this.details.open = false;
      history.pushState(null, '', link.getAttribute('href'));
      this.jump(target, true);
    }, {signal});
    this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
    window.addEventListener('scroll', this.schedule, {passive:true,signal});
    window.addEventListener('resize', this.schedule, {passive:true,signal});
    window.addEventListener('hashchange', () => this.fromHash(), {signal});
    this.mobile.addEventListener('change', () => { this.details.open = !this.mobile.matches; this.schedule(); }, {signal});
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.build());
    this.observer.observe(this.body, {childList:true,subtree:true,characterData:true});
    this.fromHash();
  }
  build() {
    this.headings = [...this.body.querySelectorAll('h2')].filter(h => h.textContent.trim());
    const ids = [...document.querySelectorAll('[id]')].map(e => e.id);
    const used = new Set(ids), counts = new Map();
    ids.forEach(id => counts.set(id, (counts.get(id) || 0) + 1));
    this.list.replaceChildren();
    this.links = this.headings.map((heading,index) => {
      if (!heading.id || counts.get(heading.id) > 1) heading.id = DrvArticleReader.uniqueId(heading.textContent, 'article-' + this.dataset.articleId, used);
      const li = document.createElement('li'), link = document.createElement('a');
      link.textContent = heading.textContent.trim();
      link.href = '#' + encodeURIComponent(heading.id);
      link.dataset.readerIndex = index;
      li.append(link); this.list.append(li);
      return link;
    });
    this.toc.hidden = !this.headings.length;
    this.classList.toggle('is-toc-empty', !this.headings.length);
    this.update();
  }
  offset() {
    const header = document.querySelector('.header-section header[is="sticky-header"]');
    const height = header ? header.getBoundingClientRect().height : 0;
    this.style.setProperty('--reader-sticky-top', (height + 12) + 'px');
    const offset = height + 24 + (this.mobile.matches && !this.toc.hidden ? this.details.querySelector('summary').offsetHeight + 12 : 0);
    this.style.setProperty('--reader-anchor-offset', offset + 'px');
    return offset;
  }
  update() {
    const offset = this.offset();
    let active = -1;
    this.headings.forEach((h,i) => { if (h.getBoundingClientRect().top <= offset + 20) active = i; });
    this.links.forEach((link,i) => {
      if (i === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current');
    });
    const progress = this.querySelector('.drv-article-reader__progress span');
    if (progress) {
      const rect = this.body.getBoundingClientRect();
      const fraction = Math.max(0,Math.min(1,(offset - rect.top) / Math.max(1,rect.height - innerHeight + offset)));
      progress.style.transform = 'scaleX(' + fraction + ')';
    }
  }
  jump(target, focus) {
    requestAnimationFrame(() => {
      const top = scrollY + target.getBoundingClientRect().top - this.offset();
      window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      if (focus) { target.setAttribute('tabindex','-1'); target.focus({preventScroll:true}); }
      this.schedule?.();
    });
  }
  fromHash() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = this.headings.find(h => h.id === id);
    if (target) this.jump(target,false);
  }
  disconnectedCallback() {
    this.abort?.abort(); this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
  }
}
if (!customElements.get('drv-article-reader')) customElements.define('drv-article-reader', DrvArticleReader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-card-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const initialize = (root) => {
      if (root.dataset.drvCardSliderReady === 'true') return;

      const track = root.querySelector('[data-drv-card-slider-track]');
      const cards = [...root.querySelectorAll('[data-drv-card-slider-card]')];
      const previous = root.querySelector('[data-drv-card-slider-prev]');
      const next = root.querySelector('[data-drv-card-slider-next]');
      const progress = root.querySelector('[data-drv-card-slider-progress]');
      if (!track || cards.length === 0 || !progress) return;

      root.dataset.drvCardSliderReady = 'true';
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let frame = 0;
      let dragging = false;
      let dragStart = 0;
      let scrollStart = 0;

      const cardStep = () => {
        const styles = getComputedStyle(track);
        return cards[0].getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
      };

      const update = () => {
        frame = 0;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const visible = track.scrollWidth > 0 ? Math.min(100, track.clientWidth / track.scrollWidth * 100) : 100;
        const ratio = maximum > 0 ? Math.min(1, Math.max(0, track.scrollLeft / maximum)) : 0;
        progress.style.width = `${visible}%`;
        progress.style.left = `${ratio * (100 - visible)}%`;
        if (previous) previous.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maximum - 1;
      };

      const requestUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };

      const move = (direction) => {
        track.scrollBy({ left: cardStep() * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };

      previous?.addEventListener('click', () => move(-1), options);
      next?.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', requestUpdate, { ...options, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        dragStart = event.clientX;
        scrollStart = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }, options);
      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        event.preventDefault();
        track.scrollLeft = scrollStart - (event.clientX - dragStart);
      }, options);
      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };
      track.addEventListener('pointerup', stopDragging, options);
      track.addEventListener('pointercancel', stopDragging, options);
      const observer = new ResizeObserver(requestUpdate);
      observer.observe(track);
      cleanups.set(root, () => {
        controller.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
        track.classList.remove('is-dragging');
        delete root.dataset.drvCardSliderReady;
      });
      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-drv-product-card-slider]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-drv-product-card-slider]').forEach((root) => {
        cleanups.get(root)?.();
        cleanups.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-detail-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
  if (customElements.get('drv-product-detail-carousel')) return;
  class DrvProductDetailCarousel extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.viewport = this.querySelector('[data-viewport]');
      this.cards = [...this.querySelectorAll('.drv-product-detail-carousel__card')];
      this.previousButton = this.querySelector('[data-direction="previous"]');
      this.nextButton = this.querySelector('[data-direction="next"]');
      this.progress = this.querySelector('[data-progress]');
      this.status = this.querySelector('[data-status]');
      if (!this.viewport || !this.cards.length) return;
      this.index = 0;
      this.destination = null;
      this.previousButton?.addEventListener('click', () => this.move(-1), options);
      this.nextButton?.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.viewport.addEventListener('wheel', () => { this.destination = null; }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.goTo(0);
        else if (event.key === 'End') this.goTo(this.cards.length - 1);
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.viewport.addEventListener('pointerdown', event => {
        this.destination = null;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.dragging = true;
        this.dragStart = event.clientX;
        this.scrollStart = this.viewport.scrollLeft;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
      }, options);
      this.viewport.addEventListener('pointermove', event => {
        if (!this.dragging) return;
        event.preventDefault();
        this.viewport.scrollLeft = this.scrollStart + this.dragStart - event.clientX;
      }, options);
      const stopDrag = event => {
        if (!this.dragging) return;
        this.dragging = false;
        this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
        this.goTo(this.nearestIndex());
      };
      this.viewport.addEventListener('pointerup', stopDrag, options);
      this.viewport.addEventListener('pointercancel', stopDrag, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.goTo(index, 'auto');
      }, options);
      this.width = this.viewport.clientWidth;
      this.resizeObserver = new ResizeObserver(() => {
        const index = this.destination ?? this.index;
        if (this.width !== this.viewport.clientWidth) {
          this.width = this.viewport.clientWidth;
          this.goTo(index, 'auto');
        }
        this.update();
      });
      this.resizeObserver.observe(this.viewport);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.viewport?.classList.remove('is-dragging');
      this.dragging = false;
      this.destination = null;
    }
    position(index) { return this.cards[index].offsetLeft - this.cards[0].offsetLeft; }
    nearestIndex() {
      let nearest = 0;
      this.cards.forEach((card, index) => {
        if (Math.abs(this.position(index) - this.viewport.scrollLeft) < Math.abs(this.position(nearest) - this.viewport.scrollLeft)) nearest = index;
      });
      return nearest;
    }
    move(direction) { this.goTo((this.destination ?? this.nearestIndex()) + direction); }
    goTo(index, behavior) {
      this.destination = Math.max(0, Math.min(this.cards.length - 1, index));
      this.viewport.scrollTo({ left: this.position(this.destination), behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
      this.update();
    }
    update() {
      this.index = this.nearestIndex();
      if (this.destination !== null && Math.abs(this.viewport.scrollLeft - this.position(this.destination)) < 2) this.destination = null;
      const boundaryIndex = this.destination ?? this.index;
      if (this.progress) this.progress.style.width = ((this.index + 1) / this.cards.length * 100) + '%';
      if (this.status) this.status.textContent = (this.index + 1) + ' / ' + this.cards.length;
      if (this.previousButton) this.previousButton.disabled = boundaryIndex === 0;
      if (this.nextButton) this.nextButton.disabled = boundaryIndex === this.cards.length - 1;
    }
  }
  if (!customElements.get('drv-product-detail-carousel')) customElements.define('drv-product-detail-carousel', DrvProductDetailCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-image-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const initialize = (root) => {
      if (root.dataset.drvImageSwitcherReady === 'true') return;

      const tabs = [...root.querySelectorAll('[data-drv-image-switcher-tab]')];
      const panels = [...root.querySelectorAll('[data-drv-image-switcher-panel]')];
      if (tabs.length === 0 || tabs.length !== panels.length) return;

      root.dataset.drvImageSwitcherReady = 'true';
      const controller = new AbortController();
      const options = { signal: controller.signal };

      let selectionVersion = 0;

      const preparePanel = async (panel) => {
        const image = panel.querySelector('img');
        if (!image || image.complete && image.naturalWidth > 0) return;
        image.loading = 'eager';
        try {
          await image.decode();
        } catch {}
      };

      const activate = async (index, moveFocus = false) => {
        const version = ++selectionVersion;
        const nextIndex = Math.min(tabs.length - 1, Math.max(0, index));
        await preparePanel(panels[nextIndex]);
        if (version !== selectionVersion || !root.isConnected) return;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === nextIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        if (moveFocus) tabs[nextIndex].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => void activate(index), options);
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          void activate(nextIndex, true);
        }, options);
      });

      const preload = () => panels.forEach((panel) => void preparePanel(panel));
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        preload();
        observer.disconnect();
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
      cleanups.set(root, () => {
        selectionVersion++;
        controller.abort();
        observer.disconnect();
        delete root.dataset.drvImageSwitcherReady;
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-drv-product-image-switcher]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-drv-product-image-switcher]').forEach((root) => {
        cleanups.get(root)?.();
        cleanups.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-longform"] && !Shopify.designMode) return;
  try {
    
  class DrvProductStorySwitcher extends HTMLElement {
    connectedCallback() {
      if (this.dataset.drvProductStoryBound === 'true') return;

      this.tabs = [...this.querySelectorAll('[data-drv-product-story-tab]')];
      this.mediaPanels = [...this.querySelectorAll('[data-drv-product-story-media]')];
      this.copyPanels = [...this.querySelectorAll('[data-drv-product-story-panel]')];

      if (!this.tabs.length || this.tabs.length !== this.mediaPanels.length || this.tabs.length !== this.copyPanels.length) return;

      this.dataset.drvProductStoryBound = 'true';
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
      this.addEventListener('shopify:block:select', (event) => {
        const mediaPanel = event.target.closest?.('[data-drv-product-story-media]');
        if (!mediaPanel || !this.contains(mediaPanel)) return;

        const stageIndex = Number(mediaPanel.dataset.stageIndex);
        if (Number.isInteger(stageIndex)) this.activate(stageIndex);
      });

      const selectedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this.activate(selectedIndex >= 0 ? selectedIndex : 0);
    }

    activate(index, moveFocus = false) {
      if (index < 0 || index >= this.tabs.length) return;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
        this.mediaPanels[tabIndex].hidden = !isActive;
        this.mediaPanels[tabIndex].classList.toggle('is-active', isActive);
        this.copyPanels[tabIndex].hidden = !isActive;
        this.copyPanels[tabIndex].classList.toggle('is-active', isActive);
      });

      if (moveFocus) {
        const tab = this.tabs[index];
        tab.focus({ preventScroll: true });
        this.ensureTabVisible(tab);
      }
    }

    ensureTabVisible(tab) {
      const rail = tab.parentElement;
      if (!rail) return;

      const railRect = rail.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      let nextScrollLeft = rail.scrollLeft;

      if (tabRect.left < railRect.left) nextScrollLeft -= railRect.left - tabRect.left;
      if (tabRect.right > railRect.right) nextScrollLeft += tabRect.right - railRect.right;

      if (nextScrollLeft !== rail.scrollLeft) {
        rail.scrollTo({ left: nextScrollLeft, behavior: 'auto' });
      }
    }

    handleKeydown(event, currentIndex) {
      const nextKeys = ['ArrowRight', 'ArrowDown'];
      const previousKeys = ['ArrowLeft', 'ArrowUp'];
      let nextIndex = currentIndex;

      if (nextKeys.includes(event.key)) nextIndex = (currentIndex + 1) % this.tabs.length;
      if (previousKeys.includes(event.key)) nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex && !['Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      this.activate(nextIndex, true);
    }
  }

  if (!customElements.get('drv-product-story-switcher')) {
    customElements.define('drv-product-story-switcher', DrvProductStorySwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-model-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drv-model-comparison')) return;
    class DrvModelComparison extends HTMLElement {
      static key(value) { return String(value || '').normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]/gu, ''); }
      static valueKey(value) { return String(value ?? '').normalize('NFKC').toLowerCase().trim().replace(/\s+/g, '').replaceAll('·', '.').replaceAll('×', 'x').replaceAll('*', 'x'); }
      static resolveRow(row) {
        const parameters = {
          power: ['Motor Power', 'Motor Power|Motor|Peak Power'],
          battery: ['Battery Capacity', 'Battery Capacity|Battery|Battery options'],
          torque: ['Torque', 'Torque'],
          range: ['Max Range', 'Max Range|Range|Mileage'],
          speed: ['Top Speed', 'Top Speed|Speed|Max Speed'],
          lighting: ['Lighting', 'Lighting|Lights|Headlight'],
          brake: ['Brake', 'Brake|Brakes|Brake System'],
          payload: ['Payload', 'Max Payload|Payload|Max Load|Load Capacity|Maximum Load'],
          suspension: ['Suspension', 'Suspension|Front Fork|Front Suspension'],
          screen: ['Screen', 'Screen|Display|Meter|LCD'],
          tire: ['Tire', 'Tire|Tires|Tyre|Tyres|Wheel Size'],
          height: ['Rider Height', 'Rider Height|User Height Range|Recommended Height|Recommended Rider Height|Height Range|Suitable Height'],
          weight: ['Weight', 'Weight|Net Weight|Bike Weight']
        };
        if (!Object.hasOwn(parameters, row.preset || '')) return row;
        const [label, aliases] = parameters[row.preset];
        return { ...row, key: row.preset, label: String(row.customLabel || '').trim() || label, aliases };
      }
      static specMap(raw) {
        const map = new Map();
        String(raw || '').split(/\r?\n/).forEach(line => {
          const separator = line.indexOf('|');
          if (separator < 0) return;
          const key = this.key(line.slice(0, separator)), value = line.slice(separator + 1).trim().replaceAll('\\"', '"');
          if (key && value) map.set(key, value);
        });
        return map;
      }
      static colorGroups(product) {
        const groups = new Map();
        product.variants.forEach(variant => {
          const color = variant.color || '';
          if (!groups.has(color)) groups.set(color, []);
          groups.get(color).push(variant);
        });
        return [...groups].map(([name, variants]) => {
          const cheapest = variants.reduce((a, b) => b.price < a.price ? b : a);
          return { name, variant: cheapest, from: variants.some(v => v.price !== cheapest.price), swatch: product.swatches?.find(s => s.name === name) };
        });
      }
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        try { this.data = JSON.parse(this.querySelector('[data-compare-data]').textContent); }
        catch { this.querySelector('[data-error]').hidden = false; return; }
        this.data.rows = this.data.rows.map(DrvModelComparison.resolveRow);
        this.products = [...new Map(this.data.products.map(p => [p.id, p])).values()];
        this.products.forEach(p => {
          p.nativeSpecs = DrvModelComparison.specMap(p.specifications);
          p.overrideSpecs = DrvModelComparison.specMap(p.overrides);
          p.colors = DrvModelComparison.colorGroups(p);
        });
        this.selected = this.products.slice(0, 3).map(p => p.id);
        this.color = new Map(this.products.map(p => [p.id, p.colors.find(c => c.name === p.defaultColor)?.name ?? p.colors[0]?.name ?? '']));
        this.menu = this.querySelector('[data-picker]');
        this.optionsRoot = this.querySelector('[data-model-options]');
        this.differences = this.querySelector('[data-differences]');
        this.heads = this.querySelector('[data-product-heads]');
        this.headScroll = this.querySelector('[data-head-scroll]');
        this.bodyScroll = this.querySelector('[data-body-scroll]');
        this.tbody = this.querySelector('[data-table-body]');
        this.thead = this.querySelector('[data-table-head]');
        this.colgroup = this.querySelector('[data-colgroup]');
        this.status = this.querySelector('[data-status]');
        this.empty = this.querySelector('[data-no-differences]');
        const markers = [...this.querySelectorAll('[data-editor-block]')];
        if (markers.length) {
          this.editorBlocks = markers.map(node => ({ id: node.dataset.editorBlock, product: node.dataset.editorProduct, row: node.dataset.editorRow, attributes: node.getAttribute('data-shopify-editor-block') }));
          markers.forEach(node => node.remove());
        }
        if (this.editorBlocks?.length) document.addEventListener('shopify:block:select', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          const block = this.editorBlocks.find(item => item.id === event.detail.blockId);
          if (!block) return;
          if (block.product && this.products.some(p => p.id === block.product) && !this.selected.includes(block.product)) this.selected = [...this.selected.slice(0, 2), block.product];
          if (block.row) this.differences.checked = false;
          this.buildOptions(); this.render();
        }, options);
        this.buildOptions();
        this.optionsRoot.addEventListener('change', event => {
          const input = event.target.closest('input[data-model-id]');
          if (input) this.toggleProduct(input.dataset.modelId, input.checked);
        }, options);
        this.differences.addEventListener('change', () => this.renderTable(), options);
        this.heads.addEventListener('click', event => {
          const button = event.target.closest('[data-color-model]');
          if (!button) return;
          this.color.set(button.dataset.colorModel, button.dataset.colorName);
          const product = this.products.find(p => p.id === button.dataset.colorModel);
          this.updateCard(product);
          this.renderTable();
        }, options);
        this.bodyScroll.addEventListener('scroll', () => {
          if (Math.abs(this.headScroll.scrollLeft - this.bodyScroll.scrollLeft) > 1) this.headScroll.scrollLeft = this.bodyScroll.scrollLeft;
        }, { ...options, passive: true });
        this.headScroll.addEventListener('scroll', () => {
          if (Math.abs(this.bodyScroll.scrollLeft - this.headScroll.scrollLeft) > 1) this.bodyScroll.scrollLeft = this.headScroll.scrollLeft;
        }, { ...options, passive: true });
        document.addEventListener('pointerdown', event => { if (!this.menu.contains(event.target)) this.menu.open = false; }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.menu.open) { this.menu.open = false; this.menu.querySelector('summary').focus(); }
        }, options);
        this.render();
      }
      disconnectedCallback() { this.controller?.abort(); }
      element(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }
      buildOptions() {
        this.optionsRoot.replaceChildren();
        this.products.forEach(product => {
          const label = this.element('label'), input = this.element('input');
          input.type = 'checkbox'; input.dataset.modelId = product.id;
          input.checked = this.selected.includes(product.id);
          label.append(input, this.element('span', '', product.title));
          this.optionsRoot.append(label);
        });
      }
      toggleProduct(id, checked) {
        if (!this.products.some(p => p.id === id)) return false;
        const selected = checked ? [...new Set([...this.selected, id])] : this.selected.filter(value => value !== id);
        if (selected.length < 1 || selected.length > 3) {
          this.optionsRoot.querySelectorAll('input').forEach(input => { input.checked = this.selected.includes(input.dataset.modelId); });
          this.status.textContent = this.data.labels.limit;
          return false;
        }
        this.selected = selected;
        this.status.textContent = '';
        this.render();
        return true;
      }
      choice(product) { return product.colors.find(c => c.name === this.color.get(product.id)) || product.colors[0]; }
      price(product) {
        const choice = this.choice(product);
        return choice ? (choice.from ? choice.variant.fromMoney : choice.variant.money) : '—';
      }
      value(product, row) {
        if (row.key === 'price') return this.price(product);
        const manual = product.manualFacts?.[row.key];
        if (manual !== undefined && manual !== null && String(manual).trim() !== '') return String(manual).trim();
        const aliases = String(row.aliases || row.label).split('|').map(DrvModelComparison.key);
        for (const map of [product.overrideSpecs]) {
          for (const alias of aliases) if (map.has(alias)) return map.get(alias);
        }
        if (product.facts && Object.hasOwn(product.facts, row.key)) return product.facts[row.key] || '—';
        for (const alias of aliases) if (product.nativeSpecs.has(alias)) return product.nativeSpecs.get(alias);
        if (row.key === 'battery' && product.battery) return product.battery;
        return '—';
      }
      render() {
        this.visibleProducts = this.products.filter(p => this.selected.includes(p.id));
        this.style.setProperty('--drv-compare-count', this.visibleProducts.length);
        this.differences.disabled = this.visibleProducts.length < 2;
        if (this.differences.disabled) this.differences.checked = false;
        const corner = this.element('div', 'drv-product-model-comparison__corner', '\u00a0');
        corner.setAttribute('aria-hidden', 'true');
        this.heads.replaceChildren(corner);
        this.visibleProducts.forEach(product => {
          const card = this.element('div', 'drv-product-model-comparison__product');
          card.dataset.productId = product.id;
          const editorBlock = this.editorBlocks?.find(block => block.product === product.id);
          if (editorBlock?.attributes) card.setAttribute('data-shopify-editor-block', editorBlock.attributes);
          const link = this.element('a', 'drv-product-model-comparison__cover');
          const img = this.element('img'); img.alt = product.title; img.loading = 'lazy'; img.width = 400; img.height = 300;
          link.append(img);
          const name = this.element('a', 'drv-product-model-comparison__name', product.title);
          const swatches = this.element('div', 'drv-product-model-comparison__swatches');
          swatches.setAttribute('role', 'group'); swatches.setAttribute('aria-label', product.title);
          product.colors.filter(c => c.name).forEach(color => {
            const button = this.element('button', 'drv-product-model-comparison__swatch');
            button.type = 'button'; button.dataset.colorModel = product.id; button.dataset.colorName = color.name;
            button.title = color.name; button.setAttribute('aria-label', color.name);
            const palette = { black:'#111111',white:'#f5f5f5',gray:'#888888',grey:'#888888',blue:'#1257b8',orange:'#f58220',red:'#c62828',green:'#377d53',silver:'#bbbbbb',yellow:'#e7c72d' };
            if (color.swatch?.image) button.style.backgroundImage = 'url("' + color.swatch.image.replaceAll('"', '%22') + '")';
            else if (color.swatch?.color) button.style.backgroundColor = color.swatch.color;
            else {
              const parts = color.name.toLowerCase().split(/[-/]/).map(s => palette[s.trim()]);
              if (parts.every(Boolean)) button.style.background = parts.length === 1 ? parts[0] : 'linear-gradient(90deg, ' + parts.map((c,i)=>c + ' ' + i/parts.length*100 + '% ' + (i+1)/parts.length*100 + '%').join(',') + ')';
              else { button.style.backgroundColor = '#ddd'; button.textContent = color.name.slice(0,1); }
            }
            swatches.append(button);
          });
          card.append(link, name, swatches); this.heads.append(card); this.updateCard(product);
        });
        this.renderTable();
        this.headScroll.scrollLeft = this.bodyScroll.scrollLeft;
      }
      updateCard(product) {
        const card = [...this.heads.children].find(node => node.dataset.productId === product.id);
        if (!card) return;
        const choice = this.choice(product), image = choice?.variant.image || product.image;
        const img = card.querySelector('img'); if (image) { img.src = image; img.hidden = false; } else img.hidden = true;
        card.querySelectorAll('a').forEach(link => { link.href = choice?.variant.url || product.url; });
        card.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colorName === choice?.name)));
      }
      renderTable() {
        this.colgroup.replaceChildren(); this.thead.replaceChildren(); this.tbody.replaceChildren();
        const headings = this.element('tr'); headings.append(this.element('th', '', this.data.labels.caption));
        this.visibleProducts.forEach(p => headings.append(this.element('th', '', p.title)));
        [...headings.children].forEach(th => th.scope = 'col'); this.thead.append(headings);
        for (let i=0; i<=this.visibleProducts.length; i++) this.colgroup.append(this.element('col'));
        let shown = 0;
        this.data.rows.forEach(row => {
          const values = this.visibleProducts.map(p => this.value(p, row));
          if (this.differences.checked && new Set(values.map(DrvModelComparison.valueKey)).size <= 1) return;
          const tr = this.element('tr'); tr.dataset.compareRow = row.key;
          const editorBlock = this.editorBlocks?.find(block => block.row === (row.id || row.key));
          if (editorBlock?.attributes) tr.setAttribute('data-shopify-editor-block', editorBlock.attributes);
          const th = this.element('th', '', row.label); th.scope = 'row'; tr.append(th);
          values.forEach(value => tr.append(this.element('td', '', value)));
          this.tbody.append(tr); shown++;
        });
        this.empty.hidden = shown > 0;
      }
    }
    customElements.define('drv-model-comparison', DrvModelComparison);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-photo-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drv-product-photo-wall')) return;
    class DrvProductPhotoWall extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.viewport = this.querySelector('[data-wall-viewport]');
        this.track = this.querySelector('[data-wall-track]');
        this.group = this.querySelector('[data-wall-group]');
        if (!this.viewport || !this.track || !this.group) return;
        this.photos = [...this.group.querySelectorAll('[data-wall-photo]')];
        this.button = this.querySelector('[data-wall-pause]');
        this.duration = Math.max(1, Number(this.dataset.duration) || 60) * 1000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.phase = 0;
        this.distance = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.sync(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
        this.button?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.button.setAttribute('aria-pressed', String(this.userPaused));
          this.button.textContent = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
          this.sync();
        }, options);
        this.viewport.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.focused = true;
          this.sync();
          if (event.key === 'Home') this.phase = 0;
          else if (event.key === 'End') this.phase = this.distance - this.step;
          else this.phase += event.key === 'ArrowRight' ? this.step : -this.step;
          this.paint();
        }, options);
        this.viewport.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.focused = false;
          this.drag = { x: event.clientX, y: event.clientY, phase: this.phase, id: event.pointerId, active: false };
          this.sync();
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag) return;
          const dx = this.drag.x - event.clientX, dy = this.drag.y - event.clientY;
          if (!this.drag.active) {
            if (Math.abs(dx) < 4 || Math.abs(dx) <= Math.abs(dy)) return;
            this.drag.active = true;
            this.viewport.classList.add('is-dragging');
            this.viewport.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.phase = this.drag.phase + dx;
          this.paint();
        }, options);
        const release = () => {
          if (this.drag && this.viewport.hasPointerCapture(this.drag.id)) this.viewport.releasePointerCapture(this.drag.id);
          this.drag = null;
          this.viewport.classList.remove('is-dragging');
          this.sync();
        };
        this.viewport.addEventListener('pointerup', release, options);
        this.viewport.addEventListener('pointercancel', release, options);
        this.addEventListener('shopify:block:select', event => {
          const photo = this.photos.find(p => p === event.target || p.contains(event.target));
          if (photo) {
            this.focused = true;
            this.phase = photo.offsetLeft - this.photos[0].offsetLeft;
            this.paint();
            this.sync();
          }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.focused = false; this.sync(); }, options);
        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this.viewport);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.sync();
        });
        this.intersectionObserver.observe(this);
        this.layout();
      }
      clone(element) {
        const clone = element.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
        return clone;
      }
      layout() {
        if (!this.photos?.length) return;
        const ratio = this.distance ? this.phase / this.distance : 0;
        this.track.querySelectorAll('[data-wall-clone]').forEach(node => node.remove());
        this.group.querySelectorAll('[data-wall-fill]').forEach(node => node.remove());
        const base = this.group.getBoundingClientRect().width;
        if (base <= 0) { this.distance = 0; this.sync(); return; }
        const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / base));
        for (let i = 1; i < copies; i++) this.photos.forEach(photo => {
          const clone = this.clone(photo);
          clone.setAttribute('data-wall-fill', '');
          this.group.append(clone);
        });
        this.distance = this.group.getBoundingClientRect().width;
        this.phase = ratio * this.distance;
        this.step = this.photos.length > 1 ? this.photos[1].offsetLeft - this.photos[0].offsetLeft : base;
        for (let i = 0; i < 2; i++) {
          const clone = this.clone(this.group);
          clone.removeAttribute('data-wall-group');
          clone.setAttribute('data-wall-clone', '');
          if (i === 0) this.track.prepend(clone);
          else this.track.append(clone);
        }
        this.paint();
        this.sync();
      }
      paint() {
        if (!this.distance) return;
        this.phase = ((this.phase % this.distance) + this.distance) % this.distance;
        this.track.style.transform = 'translate3d(' + (-this.distance - this.phase) + 'px, 0, 0)';
      }
      sync() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
        const running = this.autoplay && this.visible && !document.hidden && !this.motion?.matches && !this.userPaused && !this.hovered && !this.focused && !this.drag && this.distance > 0;
        this.classList.toggle('is-running', Boolean(running));
        if (running) this.frame = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        if (this.lastTime !== null) this.phase += Math.min(64, time - this.lastTime) * this.distance / this.duration;
        this.lastTime = time;
        this.paint();
        this.frame = requestAnimationFrame(next => this.tick(next));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = null;
        this.drag = null;
        this.classList.remove('is-running');
        this.viewport?.classList.remove('is-dragging');
        this.track?.querySelectorAll('[data-wall-clone]').forEach(node => node.remove());
        this.group?.querySelectorAll('[data-wall-fill]').forEach(node => node.remove());
      }
    }
    customElements.define('drv-product-photo-wall', DrvProductPhotoWall);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-process-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProcessTabs = (root) => {
      if (!(root instanceof HTMLElement) || root.dataset.drvProcessReady === 'true') return;
      const buttons = [...root.querySelectorAll('[data-drv-process-tab]')];
      const panels = [...root.querySelectorAll('[data-drv-process-panel]')];
      const scroller = root.querySelector('[data-drv-process-scroller]');
      if (buttons.length !== panels.length || buttons.length === 0) return;

      const activate = (index, focus = false) => {
        const safeIndex = Math.max(0, Math.min(buttons.length - 1, index));
        buttons.forEach((button, buttonIndex) => {
          const selected = buttonIndex === safeIndex;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
          button.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const selected = panelIndex === safeIndex;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
        const activeButton = buttons[safeIndex];
        if (focus) activeButton.focus();
        if (scroller && matchMedia('(max-width: 767px)').matches) {
          const left = activeButton.offsetLeft - (scroller.clientWidth - activeButton.offsetWidth) / 2;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          scroller.scrollTo({ left: Math.max(0, left), behavior });
        }
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = buttons.length - 1;
          else return;
          event.preventDefault();
          activate(nextIndex, true);
        });
      });

      root.dataset.drvProcessReady = 'true';
    };

    const initAllProcessTabs = (scope = document) => {
      scope.querySelectorAll('[data-drv-product-process-tabs]').forEach(initProcessTabs);
    };

    initAllProcessTabs();
    document.addEventListener('shopify:section:load', (event) => initAllProcessTabs(event.target));

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-specs-geometry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('drv-product-specs-geometry')) return;
    class DrvProductSpecsGeometry extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let index = this.tabs.indexOf(tab);
            if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = this.tabs.length - 1;
            else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(this.tabs[index].dataset.tab);
            this.tabs[index].focus({ preventScroll: true });
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-panel]');
          if (panel && this.contains(panel)) this.select(panel.dataset.panel);
        }, options);
        this.querySelectorAll('[data-measurement]').forEach(row => {
          const activate = () => this.querySelectorAll('[data-measurement]').forEach(other => other.classList.toggle('is-highlighted', other === row));
          row.addEventListener('click', activate, options);
          row.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
          }, options);
        });
        this.select(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.dataset.tab || this.tabs[0]?.dataset.tab, false);
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(name, reveal = true) {
        const selected = this.tabs.find(tab => tab.dataset.tab === name);
        if (!selected) return false;
        this.tabs.forEach(tab => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const active = panel.dataset.panel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (reveal && this.tablist) {
          const left = selected.offsetLeft, right = left + selected.offsetWidth;
          if (left < this.tablist.scrollLeft) this.tablist.scrollTo({ left, behavior: 'auto' });
          else if (right > this.tablist.scrollLeft + this.tablist.clientWidth) this.tablist.scrollTo({ left: right - this.tablist.clientWidth, behavior: 'auto' });
        }
        return true;
      }
    }
    customElements.define('drv-product-specs-geometry', DrvProductSpecsGeometry);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drv-product-split-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = matchMedia('(max-width: 767px)');
    const reducedMotionQuery = matchMedia('(prefers-reduced-motion: reduce)');

    const synchronize = (root) => {
      const mobilePlayer = root.querySelector('.drv-product-split-video__player--mobile');
      const useMobilePlayer = mobileQuery.matches && mobilePlayer;
      const allowAutoplay = root.dataset.autoplay === 'true' && !reducedMotionQuery.matches;

      root.querySelectorAll('.drv-product-split-video__player').forEach((player) => {
        const isMobilePlayer = player.classList.contains('drv-product-split-video__player--mobile');
        const isActivePlayer = useMobilePlayer ? isMobilePlayer : !isMobilePlayer;
        player.toggleAttribute('autoplay', Boolean(isActivePlayer && allowAutoplay));

        player.querySelectorAll('video').forEach((video) => {
          if (!isActivePlayer || reducedMotionQuery.matches) {
            video.removeAttribute('autoplay');
            video.pause();
          }
        });
      });
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-drv-product-split-video]').forEach((root) => {
        if (root.dataset.drvSplitVideoReady === 'true') return;
        root.dataset.drvSplitVideoReady = 'true';
        root.addEventListener('loadedmetadata', () => synchronize(root), true);
        synchronize(root);
      });
    };

    initialize();
    mobileQuery.addEventListener('change', () => document.querySelectorAll('[data-drv-product-split-video]').forEach(synchronize));
    reducedMotionQuery.addEventListener('change', () => document.querySelectorAll('[data-drv-product-split-video]').forEach(synchronize));
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
